import { render, staticRenderFns } from "./ChargebackReportModal.vue?vue&type=template&id=2bf3b337"
import script from "./ChargebackReportModal.vue?vue&type=script&lang=js"
export * from "./ChargebackReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports